<div class="container m-b-20 layout-row align-end gap-20px">
  <div #buttonCreateUser class="in-block">
    <button mat-raised-button color="primary" [routerLink]="['create']">
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Create User' | translate }}
    </button>
  </div>
</div>

<div class="container container-margin">
  <div #filter class="layout-row gap-20px">
    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>
</div>

<div class="container mat-elevation-z8 container-margin">
  <h3>{{ 'labels.heading.Users' | translate }}</h3>
  <table mat-table [dataSource]="dataSource" matSort #sortUsers="matSort">
    <ng-container matColumnDef="firstname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.First Name' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.firstname }}</td>
    </ng-container>

    <ng-container matColumnDef="lastname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Last Name' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.lastname }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Email' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.email }}</td>
    </ng-container>

    <ng-container matColumnDef="officeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Office' | translate }}</th>
      <td mat-cell *matCellDef="let user">{{ user.officeName }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="[row.id]" class="select-row"></tr>
  </table>

  <mat-paginator #paginatorUsers [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
</div>
